import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { TokenStorageService } from '../auth/token-storage.service';

export const otpAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenStorage = inject(TokenStorageService);
  const accessToken = tokenStorage.accessToken();

  const isPublicAuthEndpoint = req.url.startsWith(`${environment.apiBaseUrl}/api/v1/auth/`);
  if (
    !accessToken ||
    isPublicAuthEndpoint ||
    !req.url.startsWith(`${environment.apiBaseUrl}/api/`) ||
    req.headers.has('Authorization')
  ) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } }));
};
